/** The organization-wide contacts register. Thin wrapper: the table does it all. */

import { PageHeader } from '@connect/web-shared';

import { ContactsTable } from './contacts-table';

export function ContactsPage() {
  return (
    <div className="space-y-4">
      <PageHeader
        title="Contacts"
        description="The people at your clients. Add one from the client it belongs to."
      />
      <ContactsTable />
    </div>
  );
}
